import { Component, ViewChild } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NavbarMenuItems } from '../../model/navbar.model';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';


@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterOutlet, CommonModule, RouterModule, MatSidenavModule, MatToolbarModule, MatListModule, MatIconModule, TourMatMenuModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {

  menuItems = NavbarMenuItems;
  public isMobileRes = false;
  public isDarkTheme = true;
  sidenavMode: 'over' | 'push' | 'side' = 'side'; // Default mode
  sidenavOpened = true; // Default state
  @ViewChild('sidenav') sidenav!: MatSidenav; // Capture sidenav reference
  constructor(readonly breakpointObserver: BreakpointObserver) {
    const resolution = ['(max-width: 820.98px) and (orientation: portrait), (max-width: 850px) and (orientation: landscape)']
    this.breakpointObserver.observe(resolution).subscribe(result => {
      if (result.matches) {
        this.sidenavMode = 'over';
        this.sidenavOpened = false;
        this.isMobileRes = true;
      } else {
        this.sidenavMode = 'side';
        this.sidenavOpened = true;
        this.isMobileRes = false;
      }
    });
  }
  toggleSidenav() {
    if (this.isMobileRes) {
      this.sidenav.toggle();
    }
  }

}